module.exports = __webpack_public_path__ + "static/cover_default-c5fabb114f9f148825789fb5e645e3bd.png";